import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import { NavigationEnd, Router, Scroll, RouterOutlet } from "@angular/router";
import {SaveGame} from "../../../model/saveGame";
import {AppVersion} from "../../../../app-version";
import {GameService} from "../../../services/game.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../services/auth.service";
import {LanguageService} from "../../../services/language.service";
import {DialogLineupComponent} from "../../dialog-lineup/dialog-lineup.component";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {environment} from "../../../../environment/environment";
import {MessageDialogService} from "../../../services/message-dialog.service";
import {captureExceptionWithTags} from "../../../../sentry/sentry";
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-authentificated',
    templateUrl: './authentificated.component.html',
    styleUrls: ['./authentificated.component.scss'],
    imports: [MatDrawerContainer, MatDrawer, MatButton, MatDivider, MatDrawerContent, NgClass, MatIconButton, MatIcon, RouterOutlet, TranslocoModule]
})
export class AuthentificatedComponent implements OnInit{
  game = inject(GameService);
  router = inject(Router);
  _bottomSheet = inject(MatBottomSheet);
  snackBar = inject(MatSnackBar);
  authService = inject(AuthService);
  languageService = inject(LanguageService);

  isStaging: WritableSignal<boolean> = signal(false)
  messageDialog = inject(MessageDialogService)

  ngOnInit() {
    this.isStaging.set(environment.name === 'dev' || environment.name === 'staging')
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd && !this.game.game) {
          if (this.router.url === '/') {
            window.localStorage.removeItem('gameInfo')
          }
          this.loadGame()
        }
        if (event instanceof Scroll) {
          if (event.routerEvent instanceof NavigationEnd) {
            if (event.routerEvent.url === '/') {
              window.localStorage.removeItem('gameInfo')
            }
          }
        }
      },
      (error) => {
        console.error('Erreur lors de l\'écoute des événements de navigation', error);
        captureExceptionWithTags(error, {gameId: this.game.game?.id});
      }
    );
  }

  goHome() {
    window.localStorage.removeItem('gameInfo')
    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }

  openLineupSheet() {
    this._bottomSheet.open(DialogLineupComponent, {
      data: {
        game: this.game.game,
        homeLineup: this.game.lineUp.home,
        awayLineup: this.game.lineUp.away
      },
      panelClass: 'my-bottom-sheet-lineup'
    });
  }

  saveGame() {
    const save: SaveGame = {
      game: this.game.game,
      gamePlayList: this.game.gamePlayList
    };
    window.localStorage.setItem('game', JSON.stringify(save))

    this.snackBar.open('Game saved', '', {
      horizontalPosition: 'right',
      duration: 3000
    });
  }

  loadGame() {
    const gameInfo = window.localStorage.getItem('gameInfo')
    if (gameInfo) {
      this.game.selectGame(JSON.parse(gameInfo))
    }
  }

  openV1GamePlayList() {
    this.router.navigate(['/v1-game-play-list']);
  }

  loadLocalGame() {
    const game = window.localStorage.getItem('game')
    if (!game)  {
      this.messageDialog.openMessage(
        'validation.warningTitle',
        'validation.noGameSaved',
        'validation.continue',
        'warning'
      );
      return
    }
    const save: SaveGame = JSON.parse(game)
    if (!save) {
      this.messageDialog.openMessage(
        'validation.warningTitle',
        'validation.noGameSaved',
        'validation.continue',
        'warning'
      );
      return
    }

    if (this.game.game) {
      Object.assign(this.game.game, save.game)
    } else {
      this.game.game = save.game
    }
    this.game.gamePlayList = save.gamePlayList

    // debugger
    // if (this.router.url === '/') {
    this.router.navigate(['/game-play']);
    // }

    setTimeout(() => {
      this.snackBar.open('Game loaded', '', {
        horizontalPosition: 'right',
        duration: 3000
      });
    }, 1000)
  }

  importFakeData() {
    this.game.initFakeData()
  }

  async logout() {
    await this.authService.signOut().then(() => {
      this.router.navigate(['/login']);
    });
  }

  protected readonly APP_VERSION = AppVersion;
  protected readonly AppVersion = AppVersion;
}

if (typeof Worker === 'undefined') {
  alert(`Attention!\nCe fureteur n'est pas supporté.\nVeuillez utiliser un fureteur moderne pour utiliser cette application.`)
}
